import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {redirectForDownload} from 'BenchlingUtil';
import ToastMessage from 'nav/toasts/ToastMessage';
import notifications from 'notifications';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

interface ExportChatSessionResponse {
  url: string;
}

/** Overflow-menu label for chat PDF/zip export (sentence case). */
export const EXPORT_CHAT_DISPLAY_STRING = 'Export chat';

export function isChatExportEnabled(): boolean {
  return BenchlingConfig.LLM_ENABLE_CHAT_EXPORT;
}

export async function exportChatSession(chatSessionId: string): Promise<void> {
  const notificationId = `chat-export:${chatSessionId}`;
  notifications.info('Starting chat export...', {id: notificationId, duration: 0});
  try {
    const response = (await TaskRunner.postJSONPromise({
      url: `/1/api/chats/${chatSessionId}:export`,
    })) as ExportChatSessionResponse;
    redirectForDownload(response.url);
    notifications.success('Chat export downloaded successfully.', {id: notificationId});
  } catch (e) {
    if (net.isServerRequestError(e)) {
      notifications.error(
        <ToastMessage header="Failed to export chat" body={notifications.getFriendlyErrorAsElement(e, '')} />,
        {id: notificationId}
      );
    } else {
      notifications.close(notificationId);
      throw e;
    }
  }
}
